const COMPOSER_BLUR_LAYERS = 8;
const COMPOSER_BLUR_STEP_PX = 1.25;

export function ComposerGradualBlur({ height }: { height: number }) {
    return (
        <div
            aria-hidden
            className="pointer-events-none absolute inset-x-0 bottom-0"
            style={{ height }}
        >
            {Array.from({ length: COMPOSER_BLUR_LAYERS }, (_, index) => {
                const start = (index / COMPOSER_BLUR_LAYERS) * 100;
                const end = ((index + 1) / COMPOSER_BLUR_LAYERS) * 100;
                const mask = `linear-gradient(to bottom, transparent ${start}%, black ${end}%)`;

                return (
                    <div
                        key={`blur-layer-${index.toString()}`}
                        className="absolute inset-0"
                        style={{
                            backdropFilter: `blur(${COMPOSER_BLUR_STEP_PX}px)`,
                            WebkitBackdropFilter: `blur(${COMPOSER_BLUR_STEP_PX}px)`,
                            maskImage: mask,
                            WebkitMaskImage: mask,
                        }}
                    />
                );
            })}
        </div>
    );
}
